export default "__VITE_ASSET__1ad54b28__"